/* LUMUNO · Warm (v3) — videos (load after the page, muted loops), pack selector (1 or 2 units), cart "add one more" nudge, a11y patches. */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var mobile = window.matchMedia && window.matchMedia('(max-width: 749px)').matches;
  // Speed (Oct 25): data saver on, or a very slow connection (2G/3G class) → posters only, no auto-loading videos.
  // Browsers that don't report the connection (Safari, Firefox) are treated as normal. Gallery clips still play when
  // the shopper swipes to them, since that's their choice.
  var conn = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
  var slow = !!(conn && (conn.saveData || /^(slow-2g|2g|3g)$/.test(conn.effectiveType || '')));

  /* ---------------- videos ---------------- */
  // phones: the smallest rendition; screens under 1400 px: 720p; bigger screens: 1080p
  function pick(v) {
    if (mobile && v.dataset.sd) return v.dataset.sd;
    if (window.innerWidth < 1400 && v.dataset.md) return v.dataset.md;
    return v.dataset.hd || v.dataset.md || v.dataset.sd;
  }
  // Videos never compete with the first paint: nothing loads until the page has finished loading (+ a short idle).
  var ready = document.readyState === 'complete' && performance.now() > 2500;
  var waiting = [];
  function flush() {
    ready = true;
    waiting.splice(0).forEach(function (box) { if (box.__lwVis || (box.hasAttribute('data-eager') && box.getClientRects().length)) start(box); });
  }
  if (!ready) {
    var go = function () { setTimeout(function () { (window.requestIdleCallback || function (f) { setTimeout(f, 1); })(flush, { timeout: 1500 }); }, 800); };
    if (document.readyState === 'complete') go(); else window.addEventListener('load', go, { once: true });
  }
  function start(box) {
    if (!ready) { if (waiting.indexOf(box) < 0) waiting.push(box); return; }
    var v = box.querySelector('video');
    if (!v || v.__lw) return;
    v.__lw = true;
    if (reduce) return;
    if (slow && !box.classList.contains('lw-gallery-video')) return;
    var src = pick(v);
    if (!src) return;
    v.muted = true; v.defaultMuted = true; v.playsInline = true;
    v.setAttribute('muted', ''); v.setAttribute('playsinline', ''); v.setAttribute('webkit-playsinline', '');
    v.src = src;
    v.addEventListener('playing', function () { box.classList.add('is-playing'); }, { once: true });
    var p = v.play();
    if (p && p.catch) p.catch(function () {});
  }
  var io = null, gio = null;
  function onSeen(entries) {
    entries.forEach(function (e) {
      var v = e.target.querySelector('video');
      e.target.__lwVis = e.isIntersecting;
      if (e.isIntersecting) {
        start(e.target);
        if (v && v.__lw && v.src && v.paused && !reduce) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
      } else if (v && v.__lw && !v.paused) {
        v.pause();
      }
    });
  }
  function initVideos(root) {
    var boxes = (root || document).querySelectorAll('[data-lw-video]');
    if (!boxes.length) return;
    if (!io && 'IntersectionObserver' in window) {
      io = new IntersectionObserver(onSeen, { rootMargin: '240px 0px' });
      // product gallery clips: only when the slide is actually showing (not the peek of the next slide)
      gio = new IntersectionObserver(onSeen, { threshold: 0.6 });
    }
    boxes.forEach(function (box) {
      if (box.__lwSeen) return;
      box.__lwSeen = true;
      var gallery = box.classList.contains('lw-gallery-video');
      if (!io || (!gallery && box.hasAttribute('data-eager') && box.getClientRects().length)) start(box);
      if (io) (gallery ? gio : io).observe(box);
    });
  }

  /* ---------------- money ---------------- */
  function money(cents) {
    var fmt = (window.LW_PACK && window.LW_PACK.moneyFormat) || '${{amount}}';
    var amount = (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt.replace(/\{\{\s*amount\s*\}\}/, amount).replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100));
  }
  // Shopify takes the 10% off each unit and rounds it DOWN to the cent (2 × $39.99 → $7.98 off, $72.00).
  function unitOff(cents, pct) { return Math.floor(cents * pct / 100); }

  /* ---------------- pack selector ---------------- */
  // Horizon re-renders the buy box when the finish changes; one shared state survives re-renders and only the newest setup reacts.
  var PACK = window.__lwPackState || (window.__lwPackState = { gen: 0, mode: '1', unit2: null, picked: false });
  function initPack() {
    var el = document.querySelector('.lw-pack-wrap[data-lw-pack]');
    if (!el || el.__lw) return;
    el.__lw = true;
    var gen = ++PACK.gen;
    var data = JSON.parse(el.querySelector('[data-lw-pack-json]').textContent);
    window.LW_PACK = data;
    var pct = data.percent;
    var units = el.querySelector('[data-lw-units]');
    var u1name = el.querySelector('[data-lw-u1]');
    var price1 = el.querySelector('[data-lw-price1]');
    var total2 = el.querySelector('[data-lw-total2]');
    var save2 = el.querySelector('[data-lw-save2]');
    var chips = Array.prototype.slice.call(el.querySelectorAll('[data-lw-chip]'));
    var err = el.querySelector('[data-lw-err]');
    chips.forEach(function (c) { var cv = null; for (var k = 0; k < data.variants.length; k++) if (String(data.variants[k].id) === String(c.dataset.id)) cv = data.variants[k]; if (cv) c.setAttribute('aria-label', 'Hearth 2 finish: ' + cv.title + ', ' + money(cv.price)); });

    function live() { return gen === PACK.gen && document.documentElement.contains(el); }
    function section() { return el.closest('.product-information') || document.querySelector('.product-information'); }
    // Horizon renders more than one /cart/add form in the buy box; treat all of them as ours (looked up fresh each time)
    function forms() { var s = section(); return s ? Array.prototype.slice.call(s.querySelectorAll('form[action*="/cart/add"]')) : []; }
    function ours(f) { return !!f && forms().indexOf(f) > -1; }
    function variant(id) { id = String(id); for (var i = 0; i < data.variants.length; i++) if (String(data.variants[i].id) === id) return data.variants[i]; return null; }
    function currentId() {
      var f = forms()[0];
      var input = f && f.querySelector('input[name="id"]');
      var m = /[?&]variant=(\d+)/.exec(location.search);
      return input && input.value ? input.value : (m ? m[1] : data.variants[0].id);
    }
    // Hearth 2 follows Hearth 1 until the shopper picks a finish for it
    function pair() {
      var v1 = variant(currentId()) || data.variants[0];
      var v2 = (PACK.picked && variant(PACK.unit2)) || v1;
      return [v1, v2];
    }
    function render() {
      if (!live()) return;
      var p = pair(), v1 = p[0], v2 = p[1];
      var off = unitOff(v1.price, pct) + unitOff(v2.price, pct);
      if (price1) price1.textContent = money(v1.price);
      if (total2) total2.textContent = money(v1.price + v2.price - off);
      if (save2) save2.textContent = 'You save ' + money(off);
      if (u1name) u1name.textContent = v1.title;
      chips.forEach(function (c) { var on = String(c.dataset.id) === String(v2.id); c.setAttribute('aria-checked', on ? 'true' : 'false'); c.tabIndex = on ? 0 : -1; });
      var s = section();
      if (s) s.setAttribute('data-lw-pack', PACK.mode);
      if (units) units.hidden = PACK.mode !== '2';
    }
    var r = el.querySelector('input[name="lw-pack"][value="' + PACK.mode + '"]');
    if (r) r.checked = true;
    // ?pack=2 preselects the 2-pack (cart nudge link)
    if (gen === 1 && /[?&]pack=2\b/.test(location.search)) { var r2 = el.querySelector('input[name="lw-pack"][value="2"]'); if (r2) { r2.checked = true; PACK.mode = '2'; } }

    el.addEventListener('change', function (e) {
      if (!live()) return;
      if (e.target && e.target.name === 'lw-pack') { PACK.mode = e.target.value; if (err) err.textContent = ''; render(); }
    });
    chips.forEach(function (c, i) {
      c.addEventListener('click', function () { if (!live()) return; PACK.unit2 = c.dataset.id; PACK.picked = true; render(); });
      c.addEventListener('keydown', function (e) {
        var k = e.key, n = null;
        if (k === 'ArrowRight' || k === 'ArrowDown') n = chips[(i + 1) % chips.length];
        if (k === 'ArrowLeft' || k === 'ArrowUp') n = chips[(i - 1 + chips.length) % chips.length];
        if (n) { e.preventDefault(); n.focus(); n.click(); }
      });
    });
    document.addEventListener('change', function (e) {
      if (!live()) return;
      if (e.target && e.target.closest && e.target.closest('variant-picker, .variant-picker, [data-variant-picker]')) setTimeout(render, 60);
    });
    document.addEventListener('variant:update', function () { setTimeout(render, 30); });
    var f0 = forms()[0], idInput = f0 && f0.querySelector('input[name="id"]');
    if (idInput && 'MutationObserver' in window) new MutationObserver(function () { render(); }).observe(idInput, { attributes: true, attributeFilter: ['value'] });
    render();

    // 2-pack add to cart: both units in one request, then open the cart drawer
    window.addEventListener('submit', function (e) {
      if (!live() || PACK.mode !== '2' || !ours(e.target)) return;
      e.preventDefault(); e.stopImmediatePropagation();
      addTwo();
    }, true);
    window.addEventListener('click', function (e) {
      if (!live() || PACK.mode !== '2') return;
      var btn = e.target.closest && e.target.closest('button[type="submit"], .add-to-cart-button, [name="add"]');
      if (!btn) return;
      var inSticky = btn.closest('sticky-add-to-cart, .sticky-add-to-cart__bar');
      if (!ours(btn.form) && !inSticky) return;
      e.preventDefault(); e.stopImmediatePropagation();
      addTwo(btn);
    }, true);
    function addTwo(btn) {
      if (PACK.busy) return; PACK.busy = true;
      var p = pair(), v1 = p[0], v2 = p[1];
      var lines = String(v1.id) === String(v2.id)
        ? [{ merchandiseId: 'gid://shopify/ProductVariant/' + v1.id, quantity: 2 }]
        : [{ merchandiseId: 'gid://shopify/ProductVariant/' + v1.id, quantity: 1 }, { merchandiseId: 'gid://shopify/ProductVariant/' + v2.id, quantity: 1 }];
      if (btn) btn.classList.add('is-loading');
      if (err) err.textContent = '';
      var actions = window.Shopify && window.Shopify.actions;
      var q = actions && actions.updateCart
        ? actions.updateCart({ lines: lines }, { event: { context: 'product' } }).then(function (res) {
            if (res && res.userErrors && res.userErrors.length) throw new Error(res.userErrors[0].message);
            setTimeout(function () { try { actions.openCart(); } catch (x) { location.href = '/cart'; } }, 300);
          })
        : fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: lines.map(function (l) { return { id: l.merchandiseId.split('/').pop(), quantity: l.quantity }; }) }) })
            .then(function (res) { if (!res.ok) throw new Error('Could not add to cart'); location.href = '/cart'; });
      q.catch(function (x) { if (err) err.textContent = (x && x.message) || 'Something went wrong. Please try again.'; })
       .finally(function () { PACK.busy = false; if (btn) btn.classList.remove('is-loading'); });
    }
  }

  /* ---------------- cart nudge: add one more ---------------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-lw-addone]');
    if (!b) return;
    e.preventDefault();
    var actions = window.Shopify && window.Shopify.actions;
    if (!actions || !actions.updateCart) { location.href = b.getAttribute('href') || '/cart'; return; }
    b.classList.add('is-loading');
    actions.updateCart({ lines: [{ merchandiseId: 'gid://shopify/ProductVariant/' + b.dataset.lwAddone, quantity: 1 }] }, { event: { context: 'cart' } })
      .then(function () { try { actions.openCart(); } catch (x) {} })
      .finally(function () { b.classList.remove('is-loading'); });
  });

  /* ---------------- accessibility patches for Horizon controls ---------------- */
  var a11yQueued = false;
  function a11y() {
    a11yQueued = false;
    // slideshow dots / thumbnails use aria-selected, which needs role="tab" inside a role="tablist"
    document.querySelectorAll('button.slideshow-control[aria-selected]:not([role])').forEach(function (b) {
      var p = b.parentElement, list = p;
      if (!p) return;
      if (p.tagName === 'LI' && p.parentElement && /^(OL|UL)$/.test(p.parentElement.tagName)) {
        // dots: <ol><li><button>: the list becomes the tablist, its items are presentational
        list = p.parentElement;
        Array.prototype.forEach.call(list.children, function (li) { li.setAttribute('role', 'presentation'); var x = li.querySelector('button'); if (x) x.setAttribute('role', 'tab'); });
      } else {
        var allButtons = Array.prototype.every.call(p.children, function (c) { return c.tagName === 'BUTTON'; });
        if (!allButtons) return;
        Array.prototype.forEach.call(p.children, function (c) { c.setAttribute('role', 'tab'); });
      }
      if (!list.hasAttribute('role')) { list.setAttribute('role', 'tablist'); list.setAttribute('aria-label', 'Choose a photo'); }
    });
    // sticky add-to-cart: the text is hidden on small screens, so give the button a name
    document.querySelectorAll('.sticky-add-to-cart__button:not([aria-label])').forEach(function (b) { b.setAttribute('aria-label', 'Add to cart'); });
  }
  function queueA11y() { if (a11yQueued) return; a11yQueued = true; setTimeout(a11y, 50); }

  function init() {
    initVideos(); initPack(); a11y();
    // Horizon swaps the gallery (and other parts) when the finish changes: pick up new video boxes
    if ('MutationObserver' in window) new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var added = muts[i].addedNodes;
        if (added.length) queueA11y();
        for (var j = 0; j < added.length; j++) {
          var n = added[j];
          if (n.nodeType === 1 && (n.matches('[data-lw-video], .lw-pack-wrap') || n.querySelector('[data-lw-video], .lw-pack-wrap'))) { initVideos(); initPack(); return; }
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function (e) { initVideos(e.target); initPack(); });
})();
